import { createContext, useContext } from 'react';
import { IChooseWorkplaceOverlayContext } from './types';

export const ChooseWorkplaceOverlayContext = createContext<IChooseWorkplaceOverlayContext | null>(null);

export const useChooseWorkplaceOverlayContext = (): IChooseWorkplaceOverlayContext | null => {
  return useContext(ChooseWorkplaceOverlayContext);
};
